import React from 'react';
import './VisionMissionAbout.css';
import visionImage from '../../assets/images/visionImage.jpg';
import missionImage from '../../assets/images/missionImage.jpg';
export default function VisionMissionAbout() {
  return (
   <>
   <section className="vision-mission-section_rr55">
      <div className="container_rr55">
        <div className="vision_rr55">
          <div className="image-container_rr55">
            <img
              src={visionImage}
              alt="Vision"
              className="image_rr55"
            />
          </div>
          <div className="content_rr55">
            <h2 className="heading_rr55">Our Vision</h2>
            <p className="description_rr55">
              To become a globally recognized leader in regulatory consulting and 
              statutory compliance, empowering industries to achieve operational 
              excellence and sustainable growth. SARS India Liaison envisions a 
              future where businesses seamlessly navigate complex statutory landscapes 
              with confidence, trust, and efficiency.
            </p>
          </div>
        </div>
        <div className="mission_rr55">
          <div className="content_rr55">
            <h2 className="heading_rr55">Our Mission</h2>
            <p className="description_rr55">
              To provide tailored consultancy solutions that address the unique 
              regulatory and statutory requirements of our clients. By leveraging 
              our expertise and fostering a culture of innovation and professionalism, 
              we aim to assist organizations in achieving compliance, obtaining 
              necessary approvals, and thriving in competitive markets with 
              integrity and precision.
            </p>
          </div>
          <div className="image-container_rr55">
            <img
              src={missionImage}
              alt="Mission"
              className="image_rr55"
            />
          </div>
        </div>
      </div>
    </section>
   
   
   
   
   
   
   </>
  )
}
